import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CreateProcurementSupplierDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";
import { ACTION_GET_PROCUREMENT_SUPPLIERS } from "../GetProcurementSuppliers";

import { procurementApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_PROCUREMENT_SUPPLIER = "CREATE_PROCUREMENT_SUPPLIER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const createProcurementSupplier = async (
  params: CreateProcurementSupplierDto,
): Promise<void> => {
  const response =
    await procurementApi.procurementControllerCreateProcurementSupplier(params);

  return response.data;
};

export const useCreateProcurementSupplier = (
  user: UserProfileDto | null,
): {
  createProcurementSupplier: (params: CreateProcurementSupplierDto) => void;
  createProcurementSupplierAsync: (
    params: CreateProcurementSupplierDto,
  ) => Promise<void>;
  createProcurementSupplierEnabled: boolean;
  isSuccessCreateProcurementSupplier: boolean;
  isPendingCreateProcurementSupplier: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_PROCUREMENT, ACTION_CREATE_PROCUREMENT_SUPPLIER],
    mutationFn: enabled ? createProcurementSupplier : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PROCUREMENT, ACTION_GET_PROCUREMENT_SUPPLIERS],
      });
    },
  });

  return {
    createProcurementSupplier: mutate,
    createProcurementSupplierAsync: mutateAsync,
    createProcurementSupplierEnabled: enabled,
    isSuccessCreateProcurementSupplier: isSuccess,
    isPendingCreateProcurementSupplier: isPending,
  };
};
